import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { AddinsurancepopupComponent } from './addinsurancepopup/addinsurancepopup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { Input } from '@angular/core';
@Component({
  selector: 'app-insurance',
  templateUrl: './insurance.component.html',
  styleUrls: ['./insurance.component.css']
})
export class InsuranceComponent implements OnInit {

  @ViewChild('filterbar', { static: false }) filterbar;

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;
  isfilter: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  formname: string = "Insurance";

  filterstatus: string = "ALL";
  insuranceColl: any = [];

  @Input()  empid: number = 0;


  constructor(private appService: AppdataService, private loginService: LoginserviceService, public router: Router, private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService, private datePipe: DatePipe, private toastr: ToastrService, private productFindService: NgbModal) {
    this.fnServiceChanges();
  }

  //Company Check
  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }

      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  //Init
  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    this.fngetInsurance();
  }


  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');


  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }



  fnActionRefreshClick() {
    this.fngetInsurance()
  }

  fnApplyFilter(data) {
    //this.isfilter = !this.isfilter;

    this.filterstatus = data;

    this.fngetInsurance();

  }

  fnCurrentRouteChange() {
    var queryParams = {};


    if (this.filterstatus != '') {
      queryParams['status'] = this.filterstatus;
    }

    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: queryParams,

      });
  }

  fnRemoveFilter(type) {

    if (type === 'INACTIVE') {
      this.filterstatus = "";
      this.fngetInsurance();
    }
    else {
      this.filterstatus = "";
      this.fngetInsurance();
    }
  }



  //Get
  fngetInsurance() {
    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
      'insuranceid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'empid':this.empid,
      'filterstatus': this.filterstatus
    }
    this.appService.getInsuranceListview(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.insuranceColl = res.json().result;

          } else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }

  fnAddForm() {
    try {
      this.router.navigate(['/AddInsurance']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnEditForm(deptid) {
    try {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'id': deptid,
        }
      }

      this.router.navigate(['/AddInsurance'], navigationExtras);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  public fnDeleteConfirm(deptid) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete Insurance?')
        .then((confirmed) => {
          if (confirmed) {
            this.fnDeleteForm(deptid)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnDeleteForm(deptid) {
    var data = {
      'insuranceid': deptid,
    }
    this.appService.fnDeleteInsurance(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.toastr.success('', " The Insurance has been deleted successfully.");
            this.fnInsertActivityLog('DELETE', deptid,'');
            this.fngetInsurance();
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnAddInsurance() {

    const modalRef = this.productFindService.open(AddinsurancepopupComponent, { size: <any>'l' });


    modalRef.componentInstance.empid = this.empid;
    modalRef.componentInstance.fnSetEmployee();

    
      
    modalRef.result.then(() => {
      this.fngetInsurance()
    }, () => {
      this.fngetInsurance()
    })

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
        this.fngetInsurance()

    });
  }
  fnActionEditClick(index) {


    const modalRef = this.productFindService.open(AddinsurancepopupComponent, { size: <any>'l' });

    var aBO=this.insuranceColl[index];

    modalRef.componentInstance.empid = this.empid;
    modalRef.componentInstance.insuranceid=aBO.insuranceid;
    modalRef.componentInstance.fngetInsurance();
    modalRef.componentInstance.fnSetEmployee();


      
    modalRef.result.then(() => {
      this.fngetInsurance()
    }, () => {
      this.fngetInsurance()
    })
    
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      this.fngetInsurance()

    });

  }


  fnDeleteInsuranceConfirm(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete details?')
        .then((confirmed) => {
          if (confirmed) {
            this.insuranceColl.splice(index, 1)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  
  private fnFocusTableRow(index, status) {
    if (index > -1) {
      if (status === 'IN') {
        this.insuranceColl[index].hoverfocus = "IN"
      }
      else {
        this.insuranceColl[index].hoverfocus = ""
      }
    }
  }



  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }
  }
  fnMomentDateFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY');//  
    }
    else {
      return '';
    }

  }
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc, companyid: this.loginService.fnGetCompanyId(),
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}
